import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const SKIP = ['/auth/login', '/auth/refresh', '/auth/register', '/auth/logout'];

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const canRetry = error.response?.status === 401 && !cfg._retried && !SKIP.some((p) => (cfg.url || '').includes(p));
  if (!canRetry) throw error;
  cfg._retried = true;
  await api.post('/auth/refresh');
  return api(cfg);
});

export const errText = (e) =>
  typeof e?.response?.data?.detail === 'string'
    ? e.response.data.detail
    : 'Something went wrong. Please try again.';
